<template>
    <div class="wrapper">
        <div class="button" @click="triggerClick">
            <img :src="icon"/>
        </div>
        <div class="text">{{text}}</div>
    </div>
</template>

<script>
	export default {
		name: "ImageButton",
		props: [ 'icon', 'text' ],
        methods:{
			triggerClick(e){
				this.$emit('click')
            }
        }
	}
</script>

<style scoped lang="scss">
    .button {
        width: 60px;
        height: 26px;
        margin: 0 5px;
        border-radius: 4px;
        background: #F4F6F8;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:active{
            background: rgba(0,0,0,.02);
        }
    }

    .text {
        padding-top: 4px;
        text-align: center;
        font-size: 12px;
        line-height: 17px;
        color: rgba(0, 0, 0, .85)
    }

    .button > img {
        height: 14px !important;
        width: 16px;
    }
</style>
